/**
 * @generated SignedSource<<830e74a1c154bc86df529453642c6045>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ItemTilesCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CarouselItemTile_viewer">;
  readonly " $fragmentType": "ItemTilesCarousel_viewer";
};
export type ItemTilesCarousel_viewer$key = {
  readonly " $data"?: ItemTilesCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTilesCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTilesCarousel_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchFavorites",
          "variableName": "fetchFavorites"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "CarouselItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c981728452d04f315a9cf19aba198c3f";

export default node;
